import { Typography } from '@material-ui/core'
import React, { PropsWithChildren } from 'react'
import styled, { css } from 'styled-components'
import { Breadcrumb, Breadcrumbs } from '../../../components/breadcrumbs/Breadcrumbs'
import { SecondaryBanner } from '../../../components/secondarybanner/SecondaryBanner'
import { rem } from '../../../utils'
import { isNotNull } from '../../../utils/nonNull'
import { GlossaryBannerFragment } from '@gql'
import { StyledTitle, StyledSubtitle } from "../../../components/secondarybanner/StyledSecondaryBanner";
import { StyledWrapper } from "../../../fragments/secondaryPageBanner";

export type SecondaryPageBannerProps = {
  banner: GlossaryBannerFragment
}

export const StyledSecondaryBanner = styled(SecondaryBanner)<{ breadcrumbs: React.ReactNode }>`
  > .MuiContainer-root {
    height: 100%;

    > .MuiGrid-container {
      height: 100%;

      > .MuiGrid-item {
        display: flex;
        flex-direction: column;
      }
    }
  }

  ${props => props.theme.breakpoints.up('md')} {
    padding-bottom: 0;

    .MuiBreadcrumbs-ol {
      margin-top: ${props => rem(20, props.theme)};
      max-width: ${props => rem(350, props.theme)};
      flex-wrap: nowrap;

      ${props => props.theme.breakpoints.up('md')} {
        max-width: ${props => rem(410, props.theme)};
      }

      .MuiBreadcrumbs-li {
        flex: 0 0 auto;
        white-space: nowrap;

        &:last-child {
          flex: 0 1 auto;
          overflow: hidden;

          > a {
            max-width: 100%;

            p {
              max-width: 100%;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
        }

        &:focus-within {
          outline: ${props => props.theme.typography.pxToRem(1)} auto -webkit-focus-ring-color;
        }
      }
    }
  }
`

export const StyledGlossaryTitle = styled(StyledTitle)`
    margin-top: ${props => rem(75, props.theme)};
    max-width: 100%;
    text-align: left;
    padding: 0;

    ${props => props.theme.breakpoints.up('md')} {
        margin-top: 0;
    }
`

export const SecondaryPageBanner: React.FC<PropsWithChildren<SecondaryPageBannerProps>> = ({ banner }) => {
  const { subTitle, title, primaryButton, secondaryButton } = banner

  return (
    <StyledWrapper>
      <StyledSecondaryBanner image glossary={true} breadcrumbs={(              
        <Breadcrumbs>
          <Breadcrumb href={'/'} home text={'Home'} />
          <Breadcrumb href={'/tools'} text={'Tools'} />
          <Breadcrumb href={'/glossary'} text={'Glossary'} />
        </Breadcrumbs>)} src={undefined}>
        {title && (
          <StyledGlossaryTitle variant="h1">{title}</StyledGlossaryTitle>
        )}
        {subTitle && (
          <StyledSubtitle>{subTitle}</StyledSubtitle>
        )}
        {(primaryButton || secondaryButton) && (
          <SecondaryBanner section glossary={true}>
            {(primaryButton && primaryButton.__typename === 'linkField_Link' && isNotNull(primaryButton.url)) && (
              <SecondaryBanner cta buttonProps={{ primary: true, buttonColor: 'orange', target: primaryButton?.target === '_blank' ? '_blank' : '_self' }} href={primaryButton.url?.replace('cms.', '') || '#'}>
                {primaryButton.customText}
              </SecondaryBanner>
            )}
            {(secondaryButton && secondaryButton.__typename === 'linkField_Link' && isNotNull(secondaryButton.url)) &&
              <SecondaryBanner cta buttonProps={{ primary: true, buttonColor: 'black', target: secondaryButton?.target === '_blank' ? '_blank' : '_self', size: 'small' }} href={secondaryButton.url?.replace('cms.', '') || '#'}>
                {secondaryButton.customText}
              </SecondaryBanner>
            }
          </SecondaryBanner>
        )}
      </StyledSecondaryBanner>
    </StyledWrapper>
  )
}
